import { defineStore } from 'pinia';
import api from '../api';

export const useAdminAuthStore = defineStore('adminAuth', {
    state: () => ({
        admin: null,
        token: localStorage.getItem('admin_token'),
        loading: false,
        error: null,
    }),
    getters: {
        isAuthenticated: (state) => !!state.token,
    },
    actions: {
        async login(username, password) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/admin/login', { username, password });
                this.token = response.data.token;
                this.admin = response.data.user;
                localStorage.setItem('admin_token', this.token);
            } catch (err) {
                this.error = err.response?.data?.message || 'Login failed';
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async logout() {
            this.loading = true;
            try {
                // Need to use admin token for this request
                // The interceptor uses 'token' (member), we need to override or handle it.
                // Or better, store admin token separately and handle in interceptor logic.
                await api.post('/admin/logout'); 
            } catch (err) {
                console.error('Logout error', err);
            } finally {
                this.token = null;
                this.admin = null;
                localStorage.removeItem('admin_token');
                this.loading = false;
            }
        },

        async fetchAdmin() {
            if (!this.token) return;
            this.loading = true;
            try {
                const response = await api.get('/admin/me');
                this.admin = response.data.admin;
            } catch (err) {
                this.token = null;
                this.admin = null;
                localStorage.removeItem('admin_token');
            } finally {
                this.loading = false;
            }
        }
    }
});
